import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { PageIntro } from "../components/PageIntro";
import { FinalCTA } from "../components/FinalCTA";

export default function Services() {
  const { t } = useLang();
  const list = t("servicesPage.list");
  return (
    <>
      <PageIntro overline={t("servicesPage.overline")} title={t("servicesPage.title")} body={t("servicesPage.body")} testId="services-intro" />

      <section className="bg-cream pb-16 lg:pb-24" data-testid="services-list">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="border-t border-border">
            {list.map((s, i) => (
              <Reveal key={s.tag} delay={i * 0.06}>
                <div className="group grid grid-cols-1 gap-4 border-b border-border py-12 transition-colors duration-500 hover:bg-sand/30 md:grid-cols-[100px_1fr_1.6fr] md:gap-10 md:px-4" data-testid={`service-${s.tag}`}>
                  <span className="font-serif text-5xl font-light leading-none text-terracotta/50">{s.tag}</span>
                  <h3 className="font-serif text-4xl text-charcoal">{s.t}</h3>
                  <p className="max-w-xl text-lg leading-relaxed text-charcoal/70">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <p className="mt-10 max-w-2xl text-base italic text-charcoal/55">{t("servicesPage.note")}</p>
          </Reveal>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
